import { FCI_ERROR } from "@searchui-searchforms/shared/fci";
import type { SearchPreferencesUpdate } from "@searchui-searchforms/shared/user-preferences";
import { fciFetch } from "@/shared/lib/fci";
import type { SaveUserPreferencesBody, SaveUserPreferencesPayload } from "./types";

const fci = {
    // POST request to persist user search preferences.
    // A rejected direct persistence remains an action failure for FCI.
    errorType: FCI_ERROR.Action,
    errorInfo: "saveSearchPreferences",
};

const saveLegacyUserPreferences = async (partnerId: number, body: SaveUserPreferencesBody) => {
    await fciFetch(`/api/search-preferences?partner=${partnerId}`, { method: "POST", body, fci });
};

const toDirectUpdate = (formData: SaveUserPreferencesPayload): SearchPreferencesUpdate => ({
    givenNameExactness: formData.givenNameExactness,
    surnameExactness: formData.surnameExactness,
    types: formData.types,
    collectionFocus: formData.collectionFocus,
    showMoreOptions: formData.showMoreOptions,
    matchAllTermsExactly: formData.matchAllTermsExactly,
    isSkipAssistPlacesModalPermanently: formData.isSkipAssistPlacesModalPermanently,
    unviewedFilterPopupShownCount: formData.unviewedFilterPopupShownCount,
    showUnviewedRecordsOnly: formData.showUnviewedRecordsOnly,
});

const saveDirectUserPreferences = async (formData: SaveUserPreferencesPayload) => {
    await fciFetch("/api/searchforms/search-preferences", {
        method: "POST",
        body: toDirectUpdate(formData),
        fci,
    });
};

export const saveSearchPreferences = async (
    partnerId: number,
    formData: SaveUserPreferencesPayload,
    useDirectSearchPreferences: boolean,
): Promise<void> => {
    if (useDirectSearchPreferences) return saveDirectUserPreferences(formData);

    await saveLegacyUserPreferences(partnerId, {
        givenNameExactness: formData.givenNameExactness ?? undefined,
        surnameExactness: formData.surnameExactness ?? undefined,
        showUnviewedRecordsOnly: formData.showUnviewedRecordsOnly,
        types: formData.types,
        showMoreOptions: formData.showMoreOptions,
        matchAll: formData.matchAllTermsExactly,
        isSkipAssistPlacesModalPermanently: formData.isSkipAssistPlacesModalPermanently,
        collectionFocus: formData.legacyCollectionFocus ?? formData.collectionFocus,
    });
};
